import { FC, ReactNode } from 'react';
import CopyUrlMenuItem from './copy-url-menu-item';
import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';
import Menu from '../menu';
import Icon from '../icon';
import { IconColor } from '../icon/helpers';

interface Props {
  children?: ReactNode;
  hideCopy?: boolean;
  menuId?: string;
  color?: IconColor;
}

const useStyles = createUseStyles((theme: Theme) => ({
  menu: {
    '& > span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  icon: {
    padding: 2,
    '&:hover': {
      backgroundColor: theme.palette.lightGray,
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const MoreMenu: FC<Props> = ({
  children,
  hideCopy = false,
  menuId = 'more-menu',
  color = 'black',
}) => {
  const styles = useStyles();
  return (
    <Menu
      menuId={menuId}
      trigger={<Icon name="more-horiz" className={styles.icon} color={color} />}
      className={styles.menu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {!hideCopy && <CopyUrlMenuItem />}
      {children}
    </Menu>
  );
};

export default MoreMenu;
